<script>
import { useEventListener } from '@vueuse/core'
import { tryOnScopeDispose } from '@vueuse/shared'
import gsap from 'gsap'
import { defineComponent, ref, watch, watchEffect } from 'vue'
export default defineComponent({
  name: 'ExpandableText',
  components: {
  },
  props: {
    height: { type: Number, default: 35 },
    expand: { type: String, default: 'Read more...' },
    collapse: { type: String, default: 'Close' },
    color: { type: String, default: '#fff' }
  },
  emits: ['expanding'],
  setup (props, { attrs, slots, emit }) {
    const expanded = ref(false)
    const btn = ref()
    const text = ref()

    let timeline, textHeight

    const toggleExpand = () => {
      if (expanded.value === true) {
        expanded.value = false
      } else {
        expanded.value = true
      }
    }

    const expandText = isExpanding => {
      timeline = gsap.timeline()
      if (isExpanding) {
        timeline.fromTo('.text', { maxHeight: props.height + 'px', opacity: 0.4 }, { maxHeight: textHeight, opacity: 1, ease: 'Power3.easeInOut', duration: 1 }, 0)
      } else {
        timeline.fromTo('.text', { maxHeight: textHeight, opacity: 1 }, { maxHeight: props.height + 'px', opacity: 0.4, ease: 'Power3.easeInOut', duration: 1 }, 0)
      }
    }

    watch(expanded, (to, from) => {
      if (expanded.value === true) {
        btn.value.textContent = props.collapse
      } else {
        btn.value.textContent = props.expand
      }
      expandText(expanded.value)
      emit('expanding', expanded.value)
    })

    watchEffect(() => {
      if (!text.value) return
      textHeight = text.value.getBoundingClientRect().height + 'px'
      text.value.style.maxHeight = props.height + 'px'
    })

    useEventListener(window, 'scroll', () => {
      if (expanded.value === true) {
        expanded.value = false
      }
    })

    tryOnScopeDispose(() => timeline && timeline.kill())

    return {
      text,
      btn,
      toggleExpand
    }
  }
})
</script>

<template>
  <div class="expandable-text">
    <div ref="text" class="text">
      <slot />
    </div>
    <div class="relative">
      <button
        ref="btn" class="label btn"
        :style="{color: `${color}`}"
        @click="toggleExpand"
      >
        {{ expand }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.text {
  overflow: hidden;
  opacity: 0.4;
}

.layer {
  position: absolute;
  top: -100%;
  left: 0;
  width: 100%;
  height: 35px;
  background: linear-gradient(180deg, rgba($c-dark-grey, 0%) 0%, rgba($c-dark-grey, 100%) 100%);

  @screen md {
    display: none;
  }
}

.btn {
  margin-top: rem(10px);
  text-decoration: underline;
}

</style>
